import { PrismaEnums } from '@airreading/schema/browser';
import { z } from 'zod';

import { schoolSchema } from './school-shared.js';

export const { Role } = PrismaEnums;
export type Role = PrismaEnums.Role;
export const roleSchema = z.nativeEnum(Role);

export const userRoleAssignmentSchema = z.object({
  role: roleSchema,
  schoolId: z.string().nullable(),
});
export type UserRoleAssignment = z.infer<typeof userRoleAssignmentSchema>;

export const userRoleSchema = z
  .object({
    id: z.string(),
    userId: z.string(),
  })
  .extend(userRoleAssignmentSchema.shape);
export type UserRole = z.infer<typeof userRoleSchema>;

export const userRoleWithSchoolSchema = userRoleSchema.extend({
  school: schoolSchema.nullable(),
});
export type UserRoleWithSchool = z.infer<typeof userRoleWithSchoolSchema>;

export const userRoleLikeSchema = userRoleWithSchoolSchema.pick({
  role: true,
  schoolId: true,
  school: true,
});
export type UserRoleLike = z.infer<typeof userRoleLikeSchema>;
